import React from 'react';
import { createGlassCard, sharedStyles } from './shared/sharedStyles.js';

const ShowDetails = ({ showDetails }) => {
  return (
    <div style={{
      width: '320px',
      ...createGlassCard(),
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      overflow: 'hidden'
    }}>
      {/* Panel Header */}
      <div style={{
        padding: '1rem 1.25rem',
        borderBottom: `1px solid ${sharedStyles.colors.primary}20`,
        background: sharedStyles.colors.surfaceAlt
      }}>
        <h2 style={{
          fontSize: '1.125rem',
          fontWeight: '600',
          color: sharedStyles.colors.textPrimary,
          margin: 0
        }}>
          Show Details
        </h2>
      </div>

      {/* Show Info */}
      <div style={{
        padding: '0.75rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto'
      }}>
        <div style={{ marginBottom: '0.75rem' }}>
          <h3 style={{
            fontSize: '0.95rem',
            fontWeight: '600',
            color: sharedStyles.colors.textPrimary,
            marginBottom: '0.125rem'
          }}>
            {showDetails.name}
          </h3>
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.75rem',
            marginBottom: '0.5rem'
          }}>
            Hosted by {showDetails.host}
          </p>
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.8rem',
            lineHeight: '1.4'
          }}>
            {showDetails.description}
          </p>
        </div>

        <div style={{ marginBottom: '0.75rem' }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Ideal Guest Profile
          </h4>
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.75rem',
            lineHeight: '1.4'
          }}>
            {showDetails.idealGuest}
          </p>
        </div>

        <div style={{ marginBottom: '0.75rem' }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Audience
          </h4>
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.75rem'
          }}>
            {showDetails.audience}
          </p>
        </div>

        <div style={{ marginBottom: '0.75rem' }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Format
          </h4>
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.75rem'
          }}>
            {showDetails.format}
          </p>
        </div>

        <div style={{ flex: 1 }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Topics Covered
          </h4>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
            {showDetails.topics.map(topic => (
              <span key={topic} style={{
                background: 'rgba(234, 88, 12, 0.1)',
                color: sharedStyles.colors.accentBrown,
                padding: '0.125rem 0.5rem',
                borderRadius: '6px',
                fontSize: '0.65rem',
                fontWeight: '500'
              }}>
                {topic}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowDetails;